"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMappingURL = void 0;

var _ = require("./");

var generateMappingURL = function generateMappingURL(currentUniverse, queryString) {
  return "https:" + (0, _.getProductUrl)('4', process.env.REACT_APP_RM_ENV) + "/map/-1?universeId=" + currentUniverse + queryString;
};

exports.generateMappingURL = generateMappingURL;